import '../../../../css/0-entry/entry.scss';
function showLoading({timeout} = {}) {
	//only show the loading if its taking more than {timeout} to load
	const t = setTimeout(() => {
		const loadingDiv = document.getElementsByClassName('loading__wrapper');
		if (loadingDiv.length > 0) {
			loadingDiv[0].classList.add('loading__wrapper--show');
			clearTimeout(t);
		}
	},timeout);
}
function loadReact() {
	return import('./../../App');
}
showLoading({timeout: 500});
loadReact();